export { PolarAreaChart } from './PolarAreaChart';
